<template>
  <div class="talent-eval-user-management">
    <yxt-drawer
      :visible.sync="drawerVisible"
      size="960px"
      :title="$t('pc_gwnl_lbl_userManagement')"
      :before-close="beforeDrawClose"
    >
      <div class="flex justify-content-between">
        <div class="flex-1">
          <yxt-button
            v-show="!isImportEval"
            type="primary"
            @click="addEvalUser"
          >
            {{ $t('pc_gwnl_eval_btn_addTesters'/*添加测评人员*/) }}
          </yxt-button>
          <!-- 导入的测评才显示 -->
          <yxt-button
            v-show="isImportEval"
            type="primary"
            @click="importEvalResult"
          >
            {{ $t('pc_gwnl_global_btn_importEvalResult'/*导入学员测评结果*/) }}
          </yxt-button>
          <!-- 导入测评不展示导入评估关系 -->
          <yxt-button
            v-if="!isImportEval"
            plain
            @click="showImportRelation"
          >
            {{ importBatchTitle }}
          </yxt-button>
          <yxt-button
            :disabled="!selection.length"
            plain
            @click="batchDelete"
          >
            {{ $t('pc_gwnl_global_batchDelete'/*批量删除*/) }}
          </yxt-button>
        </div>
        <yxt-input
          v-model="keyword"
          style="width: 240px;"
          :placeholder="$t('pc_gwnl_global_enterNameOrPosition')"
          searchable
          size="small"
          @keyup.enter.native="search()"
          @search="search()"
        />
      </div>
      <div class="mt16">
        <yxt-table
          ref="table"
          v-loading="loading"
          :data="list"
          row-key="id"
          @selection-change="handleSelectionChange"
        >
          <yxt-table-column
            type="selection"
            :reserve-selection="true"
            width="55"
            :selectable="(row) => !row.evaluationFinishRate || isImportEval"
          />
          <yxt-table-column
            min-width="150"
            prop="fullName"
            :label="$t('pc_gwnl_global_lbl_name')"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <yxtbiz-user-name :name="scope.row.fullName" />
              ({{ scope.row.userName }})
            </template>
          </yxt-table-column>
          <yxt-table-column
            prop="deptName"
            :label="$t('pc_gwnl_global_lbl_dept')"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <yxtbiz-dept-name :name="row.deptName || '--'" />
            </template>
          </yxt-table-column>
          <yxt-table-column
            prop="positionName"
            :label="$t('pc_gwnl_global_lbl_position')"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              {{ row.positionName || "--" }}
            </template>
          </yxt-table-column>
          <!-- 导入的不显示评估完成率 -->
          <yxt-table-column
            v-if="!isImportEval"
            prop="evaluationFinishRate"
            :label="$t('pc_gwnl_eval_lbl_evalFinishRate')"
          >
            <template slot-scope="scope">
              {{
                scope.row.evaluationFinishRate >= 0
                  ? Math.floor(scope.row.evaluationFinishRate * 10000) / 100 + "%"
                  : "--"
              }}
            </template>
          </yxt-table-column>
          <yxt-table-column
            width="160px"
            :label="$t('pc_gwnl_global_lbl_operate')"
            fixed="right"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row.evaluationFinishRate || isImportEval">
                <yxt-button
                  type="text"
                  @click="deleteUser(scope.row.userId)"
                >
                  {{ $t('pc_gwnl_lbl_delete') }}
                </yxt-button>
              </div>
              <div v-else>
                --
              </div>
            </template>
          </yxt-table-column>
        </yxt-table>
        <!--分页信息-->
        <div class="clearfix">
          <yxtbiz-eval-pager
            :total.sync="pager.total"
            :page.sync="pager.offset"
            :limit.sync="pager.limit"
            layout="total, prev, pager, next"
            @pagination="getList"
          >
          </yxtbiz-eval-pager>
        </div>
      </div>
    </yxt-drawer>
    <!-- 添加测评人员 -->
    <yxtbiz-eval-select-thirdparty-user
      :show-model="eType === 1"
      v-if="addUserVisible"
      :visible.sync="addUserVisible"
      :get-list="getUsers"
      :is-peer="isPeer"
      :function-code="functionCode"
      :data-permission-code="dataPermission"
      @selected="handleSelectedUsers"
    />
    <!-- 导入评估关系 start -->
    <yxtbiz-eval-import-drawer
      ref="importRelation"
      :title="importBatchTitle"
      :temp-url="tempUrl"
      i18n
      :import-methods="importMethods"
      :id="id"
      showNotify
      @success="getList"
    />
    <!-- 评估关系 -->
    <yxt-drawer
      size="960px"
      :title="$t('pc_gwnl_eval_evalRelationship')"
      :visible.sync="settingVisible"
      append-to-body
      @closed="closeSettingDrawer"
    >
      <yxtbiz-eval-evaluator-table
        v-show="!userNotify"
        ref="multipleTable"
        :datas="settingData"
        :loading="loading"
        :validate="validate"
        :multiple="false"
        :scene="scene"
        :data-permission-code="evaluatorDataPermission"
        :function-code="functionCode"
        :isSelfTest="isSelfTest"
        :relationList="relationList"
      />
      <!-- 加人后发消息时不需要定时消息设置的 -->
      <eval-notify
        v-if="userNotify"
        :id="id"
        noTiming
        isUser
        ref="evalNotify"
      />
      <div slot="footer">
        <template v-if="!userNotify">
          <yxt-button
            plain
            @click="settingVisible = false"
          >
            {{ $t("pc_gwnl_global_btn_cancel") }}
          </yxt-button>
          <yxt-button
            type="primary"
            :loading="loading"
            @click="submitSetting"
          >
            {{ $t("pc_gwnl_global_btn_next" /* 下一步 */) }}
          </yxt-button>
        </template>
        <template v-else>
          <yxt-button
            plain
            @click="userNotify = false;"
          >
            {{ $t("pc_gwnl_global_btn_previous" /* 上一步 */) }}
          </yxt-button>
          <yxt-button
            type="primary"
            :loading="loadingNotify"
            @click="postUsersNotify"
          >
            {{ $t("pc_gwnl_global_btn_confirm" /* 确认 */) }}
          </yxt-button>
        </template>
      </div>
    </yxt-drawer>
    <!-- 导入学员测评分数 :model-ids="[skillModelId]"-->
    <yxtbiz-eval-import-eval-score
      :evaluation-id="id"
      :eval-type="evalType"
      :project-id="projectId"
      :source="source"
      :title="$t('pc_gwnl_global_eval_score')"
      :visible.sync="importScoreVisible"
      module="hw"
      @success="getList"
    />
  </div>
</template>

<script>
import { addEvalTarget, getTrackPersons, postEvalRelation, importEvalRelation, thirdImportPerson, getEvalConfigs, deleteEvalusers, postUsersNotify } from './service';
import evalImportDrawer from 'yxt-biz-pc/packages/eval-create-drawer/src/components/eval-import-drawer';
import evalPager from '../../eval-create-drawer/src/components/eval-pager';
import evalSelectThirdpartyUser from 'yxt-biz-pc/packages/eval-create-drawer/src/components/eval-select-thirdparty-user';
import evalImportEvalScore from './components/eval-import-eval-score';
import evalNotify from '../../eval-create-drawer/src/components/eval-notify.vue';
import handleError from '../../eval-create-drawer/src/handleError.js';

const RELATIONTYPES = [
  { key: 'leaderRelation', type: '2' },
  { key: 'equalRelation', type: '3' },
  { key: 'subordinateRelation', type: '4' }
];
export default {
  name: 'YxtbizEvalUserManagement',
  name_zh: '测评人员管理组件',
  eventList: [{
    type: 'added',
    handler: 'drawerVisible',
    label: '组件显示和隐藏触发的事件'
  }],
  components: {
    yxtbizEvalImportDrawer: evalImportDrawer,
    yxtbizEvalPager: evalPager,
    yxtbizEvalSelectThirdpartyUser: evalSelectThirdpartyUser,
    yxtbizEvalImportEvalScore: evalImportEvalScore,
    evalNotify
  },
  mixins: [handleError],
  props: {
    visible: {
      type: Boolean,
      default: false,
      desc: '组件的显隐',
      setter: 'BooleanSetter'
    },
    id: {
      type: String,
      default: '',
      desc: '测评的id',
      setter: 'StringSetter'
    },
    // 问卷是否支持他评
    isPeer: {
      type: Boolean,
      default: true,
      desc: '问卷是否支持他评',
      setter: 'BooleanSetter'
    },
    getUsers: {
      type: Function,
      desc: '加人时列表展示的人员数据，从此方法获取',
      setter: 'FunctionSetter'
    },
    // 评估方案场景(1-胜任力 2-人格 3-通用)
    scene: {
      type: Number,
      default: 3,
      desc: '评估方案场景',
      setter: 'TabSetter',
      enums: [{
        label: '胜任力',
        value: 1
      }, {
        label: '人格',
        value: 2
      }, {
        label: '通用',
        value: 3
      }]

    },
    dataPermission: {
      type: String,
      default: 'gwdt_addassessor_extent',
      desc: '数据权限',
      setter: 'StringSetter'
    },
    functionCode: {
      type: String,
      default: 'gwnl_model_position',
      desc: '导航权限',
      setter: 'StringSetter'
    },
    evaluatorDataPermission: {
      type: String,
      default: 'gwdt_eval_tools_addassessor_extent',
      desc: '添加人员时，调用选人组件的数据权限',
      setter: 'StringSetter'
    },
    isImportEval: { // 是否为导入测评 true: 是 false 不是
      type: Boolean,
      default: false,
      desc: '是否为导入测评',
      setter: 'BooleanSetter'
    },
    evalType: { // 测训项目需要区分前后测。测评类型 1:前测测评，2:后测测评 ,3:不区分前后测
      type: Number,
      default: 3,
      desc: '测训项目需要区分前后测的测评类型',
      setter: 'TabSetter',
      enums: [{
        label: '前测测评',
        value: 1
      }, {
        label: '后测测评',
        value: 2
      }, {
        label: '不区分前后测',
        value: 3
      }]
    },
    projectId: {
      type: String,
      default: '',
      desc: '业务线，项目id, 组件会透传，测评导入成功会回调',
      setter: 'StringSetter'
    },
    from: {
      type: String,
      desc: '来源类型',
      setter: 'SelectSetter',
      enums: [{
        label: '测训项目',
        value: 'training'
      }, {
        label: '岗位地图',
        value: 'position'
      }, {
        label: '层级地图',
        value: 'map'
      }]
    },
    eType: {
      type: Number,
      default: 2,
      desc: '是否展示人员列表里的模型名称字段',
      setter: 'TabSetter',
      enums: [{
        label: '展示',
        value: 1
      }, {
        label: ' 不展示',
        value: 2
      }]
    }
  },
  data() {
    return {
      RELATIONTYPES,
      drawerVisible: false,
      list: [],
      keyword: '',
      loading: false,
      selection: [],
      addUserVisible: false,
      pager: {
        limit: 20,
        offset: 0,
        total: 0
      }, // 分页
      settingVisible: false,
      settingData: [],
      validate: false,
      showImportButton: false,
      importScoreVisible: false,
      isSelfTest: false, // 是否只有自评
      relationList: [], // 所有评估关系的集合
      userNotify: false, // 加完人后显示消息发送页面
      loadingNotify: false,
      notifyRelationData: []
    };
  },
  computed: {
    // source类型（0-单独安排；1-测训项目安排；2-人才盘点安排, 3-代运营, 4-岗位地图安排，5-层级地图 6-第三方导入，7-档案)
    source() {
      if (this.from === 'training') { // 测训
        return 1;
      } else if (this.from === 'position') { // 岗位
        return 4;
      } else if (this.from === 'map') { // 层级
        return 5;
      }
      return '';
    },
    tempUrl() {
      const urlObj = {
        peer: { zh: '导入评估关系模板', en: 'importevaluatorstemplate', ha: '導入評估關係範本' },
        self: { zh: '导入自评人员模板', en: 'selfevaluationtemplate', ha: '導入自評人員範本' }
      };
      return this.isSelfTest ? urlObj.self : urlObj.peer;
    },

    // 批量导入的名称跟随是否是自评变化
    importBatchTitle() {
      return this.isSelfTest ? this.$t('pc_gwnl_global_btn_batchimport' /* 批量导入 */) : this.$t('pc_gwnl_global_btn_importEvalRelationship'/* 导入评估关系*/);
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.drawerVisible = val;
      }
    },
    drawerVisible(val) {
      this.$emit('update:visible', val);
      this.$emit('added');
    }
  },
  created() {
    this.getList();
    this.getEvalConfigs();
  },
  methods: {
    beforeDrawClose(done) {
      done();
    },

    // 把定义添加到RELATIONTYPES和curRelations里
    setCustomConfig(customRelation) {
      const keysList = this.RELATIONTYPES.map(item => item.key);
      // 为了比较是否有相同评估人的时候把自定义评估关系带着
      customRelation.forEach(item => {
        const obj = {
          key: item.relationType,
          type: item.relationType,
          label: item.dimensionName
        };

        item.weight && !keysList.includes(item.relationType) && this.RELATIONTYPES.push(obj);
      });
    },

    // 获取配置信息
    getEvalConfigs() {
      getEvalConfigs(this.id).then(res => {
        this.showImportButton = res.enabledEqual === 1 ||
          res.enabledSubordinate === 1 ||
          res.enabledLeader === 1;

        // 是否仅有自评，来传递给组件判断
        this.isSelfTest = res.enabledSelf === 1 && res.weightSelf === 100;

        // 根据配置获取测评开启了哪些评估关系
        let relationList = [];
        const enabledList = [
          { key: 'enabledLeader', labelKey: 'pc_biz_eval_leaderRelation' },
          { key: 'enabledEqual', labelKey: 'pc_biz_eval_equalRelation' },
          { key: 'enabledSubordinate', labelKey: 'pc_biz_eval_subordinateRelation' }
        ];

        enabledList.forEach(item => {
          res[item.key] && relationList.push(this.$t(item.labelKey));
        });

        (res.customEvalConfigs || []).forEach(item => {
          relationList.push(item.dimensionName);
        });
        this.relationList = relationList;

        this.setCustomConfig(res.customEvalConfigs || []);
      }).catch(err => {
        this.handleError(err);
      });
    },
    search() {
      this.pager.offset = 0;
      this.getList();
    },
    getList() {
      if (this.loading) return;
      this.loading = true;
      const data = {
        deptIds: [],
        evaluationId: this.id,
        keyword: this.keyword.trim(),
        direction: 'desc',
        orderBy: 'evaluationFinishRate'
      };
      const params = {
        limit: this.pager.limit,
        offset: this.pager.offset
      };
      getTrackPersons(data, params).then((res) => {
        this.loading = false;
        this.list = res.datas;
        this.pager.total = res.paging.count;
        this.$refs.table.clearSelection();
      }).catch((err) => {
        this.loading = false;
        this.handleError(err);
      });
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    // 打开导入评估关系抽屉
    showImportRelation() {
      this.$refs.importRelation.show();
    },
    // 导入评估关系
    importMethods(file) {
      const formdata = new FormData();
      formdata.append('fileId', file.id);
      if (this.projectId) {
        formdata.append('projectId', this.projectId);
      }
      formdata.append('customization', file.customization ? file.customization : 0);
      if (this.scene === 2) {
        // 和业务代码对齐，未发布导入第三方评估关系传2
        formdata.append('importType', 2);
        return thirdImportPerson(formdata, this.id);
      } else {
        return importEvalRelation(formdata, this.id);
      }
    },
    // 批量删除
    batchDelete() {
      if (!this.selection.length) {
        this.$message.error(this.$t('pc_gwnl_eval_msg_selectPersonDeleted'/* 请选择需要删除的人员 */));
        return;
      };
      this.$confirm('', this.$t('pc_gwnl_eval_msg_deleted_people'), {
        confirmButtonText: this.$t('pc_gwnl_global_msg_determine'),
        cancelButtonText: this.$t('pc_gwnl_global_msg_cancel'),
        type: 'warning'
      }
      ).then(() => {
        const datas = this.selection.map((item) => {
          return {
            userId: item.userId
          };
        });
        this.postDelete(datas);
      });
    },
    // 单个删除
    deleteUser(id) {
      this.$confirm('', this.$t('pc_gwnl_eval_msg_deleted_people'), {
        confirmButtonText: this.$t('pc_gwnl_global_msg_determine'),
        cancelButtonText: this.$t('pc_gwnl_global_msg_cancel'),
        type: 'warning'
      }
      ).then(() => {
        const datas = [{ userId: id }];
        this.postDelete(datas);
      });
    },
    // 提交删除
    postDelete(datas) {
      deleteEvalusers(this.id, { datas }).then(res => {
        this.search();
        this.$message.success(this.$t('pc_gwnl_global_msg_deleteSuccess'/* 删除成功 */));
      }).catch(err => {
        this.handleError(err);
        this.$message.error(this.$t('pc_gwnl_eval_error_question_deletefailed'/* 删除失败 */));
      });
    },
    // 导入学员的测评结果
    importEvalResult() {
      this.importScoreVisible = true;
    },
    // 添加测评人员
    addEvalUser() {
      this.addUserVisible = true;
    },
    // 添加测评人员
    addEvalTargets(data) {
      this.loading = true;
      addEvalTarget(this.id, { datas: data }).then(res => {
        this.loading = false;
        const successData = res.datas.map(item => {
          return {
            ...item,
            positionId: item.positionId || null,
            positionName: item.positionName || null
          };
        });
        this.changeDatas(successData, res.failedCount);
      }).catch((err) => {
        this.handleError(err);
        this.loading = false;
      });
    },
    changeDatas(datas, failedCount) {
      this.settingData = datas;
      if (this.settingData.length > 0) {
        this.settingVisible = true;
        // `已成功添加${addDatas.length}名测评人员${failedCount > 0 ? `，失败${failedCount}名` : ''}`
        // let msg1 = this.$t('pc_gwnl_eval_msg_testersSuccessAdded', { count: this.settingData.length })
        // let msg2 = failedCount > 0 ? this.$t('pc_gwnl_eval_msg_testersFailedAdded', { count: failedCount }) : ''
        // this.$message.success(msg1 + msg2)
      }
      if (this.settingData.length === 0 && failedCount > 0) {
        this.$message.error(this.$t('pc_gwnl_eval_not_add').d('本次未成功添加人员'));
      }
    },
    // 处理选完人员
    handleSelectedUsers(users) {
      const data = users.map(item => {
        return {
          id: item.id || item.userId,
          name: item.fullname || item.name || item.userName,
          modelName: item.modelName,
          modelId: item.modelId
        };
      });
      this.addEvalTargets(data);
    },
    // 提交设置评估关系，添加到测评
    submitSetting() {
      const validate = this.$refs.multipleTable.validateDatas();
      if (!validate) return;
      const data = this.settingData.map(item => {
        const obj = {
          positionId: item.positionId,
          userId: item.userId,
          modelName: item.modelName,
          modelId: item.modelId,
          relations: []
        };
        if (this.scene === 2) {
          // 人格评估默认补充自评信息
          obj.relations.push({
            evaluatorId: obj.userId,
            type: 1
          });
        } else {
          // 360评估
          this.RELATIONTYPES.forEach(type => {
            if (item[type.key] && item[type.key].evaluators) {
              item[type.key].evaluators.forEach(evaluator => {
                obj.relations.push({
                  evaluatorId: evaluator.id,
                  type: type.type
                });
              });
            }
          });
          if (item.selfRelation) {
            obj.relations.push({
              evaluatorId: item.userId,
              type: '1'
            });
          }
        }
        return obj;
      });
      this.loading = true;
      this.notifyRelationData = data;
      postEvalRelation(this.id, { datas: data }).then(res => {
        this.loading = false;
        this.userNotify = true;
      }).catch(err => {
        this.loading = false;
        this.handleError(err);
      });
    },

    // 添加人员后发布消息
    postUsersNotify() {
      this.$refs.evalNotify.validateForm(() => {
        this.postPublish(0);
      });
    },

    postPublish() {
      this.loadingNotify = true;
      let data = this.$refs.evalNotify.getPublishParams();
      data.publish = 0;
      data.datas = this.notifyRelationData.map(item => {
        return {
          relations: item.relations,
          userId: item.userId
        };
      });
      postUsersNotify(this.id, data).then(() => {
        this.loadingNotify = false;
        this.settingVisible = false;
        this.closeSettingDrawer();
      }).catch((err) => {
        this.loadingNotify = false;
        this.handleError(err);
      });
    },

    closeSettingDrawer() {
      this.userNotify = false;
      this.search();
    }
  }
};
</script>
